import { Pipe, PipeTransform } from '@angular/core';
import { readStory } from '../interfaces/story';

@Pipe({ name: 'filterStoriesByTags' })
export class FilterStoriesByTagsPipe implements PipeTransform {

  transform(stories: readStory[], tags?: string[] | string): readStory[] {
    if (!tags || !tags.length) return stories;
    return stories.filter((story) => {
      return story.tags!.some((tag) => {
        return Array.isArray(tags) ? tags.includes(tag) : tag === tags
      })
    })
  }

}
